import * as tslib_1 from "tslib";
import * as i0 from "@angular/core";
import * as i1 from "./request.service";
export class NgoPartnerService {
    constructor(request) {
        this.request = request;
    }
    getNgoPartners() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('plantingSites/ngo-partners');
            return result.data;
        });
    }
    createNgoPartner(partner) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            console.log('creating partner');
            let result = yield this.request.post('plantingSites/create-ngo-partner', { name: partner.name, url: partner.url });
            return result.data;
        });
    }
    getById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.getApi('plantingSites/ngo-partner/' + id);
            return result.data;
        });
    }
    updateNgoPartner(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.request.patch('plantingSites/update-ngo-partner', data);
            return result.data;
        });
    }
    updateNgoPartnerPhoto(file, ngoId) {
        let formData = new FormData();
        formData.append('NgoPartnerPhoto', file, file.name);
        formData.append('NgoPartnerId', ngoId);
        return this.request.post('plantingSites/upload-planting-site-ngo-partner-photo', formData);
    }
}
NgoPartnerService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function NgoPartnerService_Factory() { return new NgoPartnerService(i0.ɵɵinject(i1.RequestService)); }, token: NgoPartnerService, providedIn: "root" });
